import { darken, brighten, getValue } from "../utils.js";

export const BUTTON = {
  "Button.Medium.Font.Size": {
    ref: "Font.Size.14"
  },
  "Button.Medium.Font.Weight": {
    ref: "Font.Weight.SemiBold"
  },
  "Button.Medium.Line.Height": {
    ref: "Input.Line.Height"
  },
  "Button.Medium.Letter.Spacing": {
    ref: "Input.Letter.Spacing"
  },
  "Button.Medium.Padding.Top": {
    defaultValue: "7px"
  },
  "Button.Medium.Padding.Left": {
    ref: "Space.16"
  },
  "Button.Medium.Padding.Bottom": {
    defaultValue: "7px"
  },
  "Button.Medium.Padding.Right": {
    ref: "Space.16"
  },
  "Button.Small.Font.Size": {
    ref: "Font.Size.13"
  },
  "Button.Small.Font.Weight": {
    ref: "Font.Weight.SemiBold"
  },
  "Button.Small.Line.Height": {
    defaultValue: "20px"
  },
  "Button.Small.Letter.Spacing": {
    defaultValue: "0px"
  },
  "Button.Small.Padding.Top": {
    ref: "Space.6"
  },
  "Button.Small.Padding.Left": {
    ref: "Space.12"
  },
  "Button.Small.Padding.Bottom": {
    ref: "Space.6"
  },
  "Button.Small.Padding.Right": {
    ref: "Space.12"
  },
  "Button.Tiny.Font.Size": {
    ref: "Font.Size.12"
  },
  "Button.Tiny.Font.Weight": {
    ref: "Font.Weight.SemiBold"
  },
  "Button.Tiny.Line.Height": {
    defaultValue: "20px"
  },
  "Button.Tiny.Letter.Spacing": {
    defaultValue: "0px"
  },
  "Button.Tiny.Padding.Top": {
    ref: "Space.2"
  },
  "Button.Tiny.Padding.Left": {
    ref: "Space.12"
  },
  "Button.Tiny.Padding.Bottom": {
    ref: "Space.2"
  },
  "Button.Tiny.Padding.Right": {
    ref: "Space.12"
  },
  "Button.Primary.Bg.Color": {
    ref: "Color.Primary.500",
    referredIn: [
      "Button.Primary.Focus.Shadow",
      "Button.Primary.Hover.Bg.Color",
      "Button.Primary.Active.Bg.Color",
      "Button.Primary.Active.Shadow"
    ]
  },
  "Button.Primary.Color": {
    ref: "Color.White"
  },
  "Button.Primary.Border.Color": {
    defaultValue: "transparent",
    referredIn: [
      "Button.Primary.Hover.Border.Color",
      "Button.Primary.Active.Border.Color"
    ]
  },
  "Button.Primary.Border.Left.Width": {
    defaultValue: "0"
  },
  "Button.Primary.Border.Right.Width": {
    defaultValue: "0"
  },
  "Button.Primary.Border.Top.Width": {
    defaultValue: "0"
  },
  "Button.Primary.Border.Bottom.Width": {
    defaultValue: "0"
  },
  "Button.Primary.Border.Top.Left.Radius": {
    defaultValue: "4px"
  },
  "Button.Primary.Border.Top.Right.Radius": {
    defaultValue: "4px"
  },
  "Button.Primary.Border.Bottom.Left.Radius": {
    defaultValue: "4px"
  },
  "Button.Primary.Border.Bottom.Right.Radius": {
    defaultValue: "4px"
  },
  "Button.Primary.Shadow": {
    defaultValue: "none"
  },
  "Button.Primary.Focus.Shadow": {
    valueFunc: (meta) => {
      return brighten(getValue("Button.Primary.Bg.Color", meta), 0.5);
    }
  },
  "Button.Primary.Active.Shadow": {
    valueFunc: (meta) => {
      return brighten(getValue("Button.Primary.Bg.Color", meta), 0.5);
    }
  },
  "Button.Primary.Hover.Bg.Color": {
    valueFunc: (meta) => {
      return darken(getValue("Button.Primary.Bg.Color", meta), 0.5);
    }
  },
  "Button.Primary.Hover.Border.Color": {
    valueFunc: (meta) => {
      return darken(getValue("Button.Primary.Border.Color", meta), 0.5);
    }
  },
  "Button.Primary.Active.Bg.Color": {
    valueFunc: (meta) => {
      return darken(getValue("Button.Primary.Bg.Color", meta), 0.5);
    }
  },
  "Button.Primary.Active.Border.Color": {
    valueFunc: (meta) => {
      return darken(getValue("Button.Primary.Border.Color", meta), 0.5);
    }
  },
  "Button.Primary.Disabled.Bg.Color": {
    ref: "Color.Primary.100"
  },
  "Button.Primary.Disabled.Color": {
    ref: "Color.Primary.300"
  },
  "Button.Primary.Disabled.Border.Color": {
    defaultValue: "transparent"
  },
  "Button.Secondary.Bg.Color": {
    ref: "Color.Gray.200",
    referredIn: [
      "Button.Secondary.Focus.Shadow",
      "Button.Secondary.Hover.Bg.Color",
      "Button.Secondary.Active.Bg.Color",
      "Button.Secondary.Active.Shadow"
    ]
  },
  "Button.Secondary.Color": {
    ref: "Color.Gray.800"
  },
  "Button.Secondary.Border.Color": {
    defaultValue: "transparent",
    referredIn: [
      "Button.Secondary.Hover.Border.Color",
      "Button.Secondary.Active.Border.Color"
    ]
  },
  "Button.Secondary.Border.Left.Width": {
    defaultValue: "0"
  },
  "Button.Secondary.Border.Right.Width": {
    defaultValue: "0"
  },
  "Button.Secondary.Border.Top.Width": {
    defaultValue: "0"
  },
  "Button.Secondary.Border.Bottom.Width": {
    defaultValue: "0"
  },
  "Button.Secondary.Border.Top.Left.Radius": {
    defaultValue: "4px"
  },
  "Button.Secondary.Border.Top.Right.Radius": {
    defaultValue: "4px"
  },
  "Button.Secondary.Border.Bottom.Left.Radius": {
    defaultValue: "4px"
  },
  "Button.Secondary.Border.Bottom.Right.Radius": {
    defaultValue: "4px"
  },
  "Button.Secondary.Shadow": {
    defaultValue: "none"
  },
  "Button.Secondary.Focus.Shadow": {
    valueFunc: (meta) => {
      return darken(getValue("Button.Secondary.Bg.Color", meta), 0.5);
    }
  },
  "Button.Secondary.Active.Shadow": {
    valueFunc: (meta) => {
      return darken(getValue("Button.Secondary.Bg.Color", meta), 0.5);
    }
  },
  "Button.Secondary.Hover.Bg.Color": {
    valueFunc: (meta) => {
      return darken(getValue("Button.Secondary.Bg.Color", meta), 0.5);
    }
  },
  "Button.Secondary.Hover.Border.Color": {
    valueFunc: (meta) => {
      return darken(getValue("Button.Secondary.Border.Color", meta), 0.5);
    }
  },
  "Button.Secondary.Active.Bg.Color": {
    valueFunc: (meta) => {
      return darken(getValue("Button.Secondary.Bg.Color", meta), 0.5);
    }
  },
  "Button.Secondary.Active.Border.Color": {
    valueFunc: (meta) => {
      return darken(getValue("Button.Secondary.Bg.Color", meta), 0.5);
    }
  },
  "Button.Secondary.Disabled.Bg.Color": {
    ref: "Color.Gray.200"
  },
  "Button.Secondary.Disabled.Color": {
    ref: "Color.Gray.300"
  },
  "Button.Secondary.Disabled.Border.Color": {
    defaultValue: "transparent"
  },
  "Button.Tertiary.Bg.Color": {
    defaultValue: "transparent"
  },
  "Button.Tertiary.Color": {
    ref: "Color.Primary.500"
  },
  "Button.Tertiary.Border.Color": {
    ref: "Color.Primary.500",
    referredIns: [
      "Button.Tertiary.Active.Bg.Color",
      "Button.Tertiary.Active.Shadow"
    ]
  },
  "Button.Tertiary.Border.Top.Width": {
    defaultValue: "1px"
  },
  "Button.Tertiary.Border.Bottom.Width": {
    defaultValue: "1px"
  },
  "Button.Tertiary.Border.Right.Width": {
    defaultValue: "1px"
  },
  "Button.Tertiary.Border.Left.Width": {
    defaultValue: "1px"
  },
  "Button.Tertiary.Border.Top.Left.Radius": {
    defaultValue: "4px"
  },
  "Button.Tertiary.Border.Top.Right.Radius": {
    defaultValue: "4px"
  },
  "Button.Tertiary.Border.Bottom.Right.Radius": {
    defaultValue: "4px"
  },
  "Button.Tertiary.Border.Bottom.Left.Radius": {
    defaultValue: "4px"
  },
  "Button.Tertiary.Shadow": {
    defaultValue: "none"
  },
  "Button.Tertiary.Active.Bg.Color": {
    valueFunc: (meta) => {
      return darken(getValue("Button.Tertiary.Border.Color", meta), 0.5);
    }
  },
  "Button.Tertiary.Active.Shadow": {
    valueFunc: (meta) => {
      return brighten(getValue("Button.Tertiary.Border.Color", meta), 0.5);
    }
  },
  "Button.Tertiary.Disabled.Bg.Color": {
    defaultValue: "transparent"
  },
  "Button.Tertiary.Disabled.Color": {
    ref: "Color.Primary.300"
  },
  "Button.Tertiary.Disabled.Border.Color": {
    ref: "Color.Primary.200"
  },
  "Button.Medium.Min.Width": {
    defaultValue: "0"
  },
  "Button.Medium.Max.Width": {
    defaultValue: "none"
  },
  "Button.Medium.Width": {
    defaultValue: "auto"
  },
  "Button.Medium.Height": {
    defaultValue: "auto"
  },
  "Button.Medium.Min.Height": {
    defaultValue: "none"
  },
  "Button.Medium.Max.Height": {
    defaultValue: "none"
  },
  "Button.Medium.Margin.Top": {
    defaultValue: "0"
  },
  "Button.Medium.Margin.Right": {
    defaultValue: "0"
  },
  "Button.Medium.Margin.Left": {
    defaultValue: "0"
  },
  "Button.Medium.Margin.Bottom": {
    defaultValue: "0"
  },
  "Button.Small.Min.Width": {
    defaultValue: "0"
  },
  "Button.Small.Max.Width": {
    defaultValue: "none"
  },
  "Button.Small.Width": {
    defaultValue: "auto"
  },
  "Button.Small.Height": {
    defaultValue: "auto"
  },
  "Button.Small.Min.Height": {
    defaultValue: "none"
  },
  "Button.Small.Max.Height": {
    defaultValue: "none"
  },
  "Button.Small.Margin.Top": {
    defaultValue: "0"
  },
  "Button.Small.Margin.Right": {
    defaultValue: "0"
  },
  "Button.Small.Margin.Left": {
    defaultValue: "0"
  },
  "Button.Small.Margin.Bottom": {
    defaultValue: "0"
  },
  "Button.Tiny.Min.Width": {
    defaultValue: "0"
  },
  "Button.Tiny.Max.Width": {
    defaultValue: "none"
  },
  "Button.Tiny.Width": {
    defaultValue: "auto"
  },
  "Button.Tiny.Height": {
    defaultValue: "auto"
  },
  "Button.Tiny.Min.Height": {
    defaultValue: "none"
  },
  "Button.Tiny.Max.Height": {
    defaultValue: "none"
  },
  "Button.Tiny.Margin.Top": {
    defaultValue: "0"
  },
  "Button.Tiny.Margin.Right": {
    defaultValue: "0"
  },
  "Button.Tiny.Margin.Left": {
    defaultValue: "0"
  },
  "Button.Tiny.Margin.Bottom": {
    defaultValue: "0"
  }
};
